import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"

import Table, { TableRow, TableColumn } from "components/Table/Table"
import Lmid from "components/Lmid/Lmid"
import ConnectedAsset from "models/ConnectedAsset"
import ArticleDescription from "components/ArticleDescription/ArticleDescription"

interface IAssetCollectionTableProps {
    connectedAssets: ConnectedAsset[]
}

const AssetCollectionTable: FC<IAssetCollectionTableProps> = ({
    connectedAssets,
}) => {
    const { t } = useTranslation()

    const tableColumns: TableColumn[] = [
        { title: t("common.lmid"), width: "30%" },
        { title: t("common.article"), width: "70%" },
    ]

    const tableRows = useMemo(() => {
        const rows: TableRow[] = []

        if (!connectedAssets) return []

        connectedAssets.forEach(ca => {
            const row: TableRow = [
                <Lmid assetId={ca.assetId} lmid={ca.lmid} labeled={ca.labeled} />,
                <ArticleDescription articleId={ca.articleId} articleDescription={ca.altArticleDescription || ca.articleDescription} />,
            ]

            rows.push(row)

        })

        return rows
    }, [connectedAssets])

    return (
        <Table
            columns={tableColumns}
            rows={tableRows}
        />
    )
}

export default AssetCollectionTable
